import { createTheme } from "@mui/material";

let theme = createTheme();
theme = createTheme({
  components: {
    MuiFormGroup: {
      styleOverrides: {
        root: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          flexDirection: 'row', 
          gap: theme.spacing(4)
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginTop: '15px',
          width: '300px',
          [theme.breakpoints.down("lg")]: {
            width: '100%'
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          transform: 'translate(5px, -25px) scale(0.85)'
        }
      }
    },
    MuiButton: {
      variants: [
        {
          props: { variant: 'outlined' },
          style: {
            minHeight: '3.5rem'
          }
        }
      ]
    }
  }
});

export default theme;